<template>
  <div class="column content-box">
    <woot-modal-header
      :header-title="$t('CAMPAIGN.ADD.TITLE')"
      :header-content="$t('CAMPAIGN.ADD.DESC')"
    />
    <form class="row" @submit.prevent="addCampaign">
      <div class="medium-12 columns">
        <woot-input
          v-model="title"
          :label="$t('CAMPAIGN.ADD.FORM.TITLE.LABEL')"
          type="text"
          :class="{ error: $v.title.$error }"
          :error="$v.title.$error ? $t('CAMPAIGN.ADD.FORM.TITLE.ERROR') : ''"
          :placeholder="$t('CAMPAIGN.ADD.FORM.TITLE.PLACEHOLDER')"
          @blur="$v.title.$touch"
        />

        <label v-if="isOngoingType" class="editor-wrap">
          {{ $t('CAMPAIGN.ADD.FORM.MESSAGE.LABEL') }}
          <woot-message-editor
            v-model="message"
            class="message-editor"
            :class="{ editor_warning: $v.message.$error }"
            :placeholder="$t('CAMPAIGN.ADD.FORM.MESSAGE.PLACEHOLDER')"
            @blur="$v.message.$touch"
          />
          <span v-if="$v.message.$error" class="editor-warning__message">
            {{ $t('CAMPAIGN.ADD.FORM.MESSAGE.ERROR') }}
          </span>
        </label>

        <label v-else-if="isOnOffType" :class="{ error: $v.message.$error }">
          {{ $t('CAMPAIGN.ADD.FORM.MESSAGE.LABEL') }}
          <textarea
            v-model="message"
            rows="5"
            type="text"
            :placeholder="$t('CAMPAIGN.ADD.FORM.MESSAGE.PLACEHOLDER')"
            @blur="$v.message.$touch"
          />
          <span v-if="$v.message.$error" class="message">
            {{ $t('CAMPAIGN.ADD.FORM.MESSAGE.ERROR') }}
          </span>
        </label>

        <label :class="{ error: $v.selectedInbox.$error }">
          {{ $t('CAMPAIGN.ADD.FORM.INBOX.LABEL') }}
          <select v-model="selectedInbox" @change="onChangeInbox($event)">
            <option v-for="item in inboxes" :key="item.name" :value="item.id">
              {{ item.name }}
            </option>
          </select>
          <span v-if="$v.selectedInbox.$error" class="message">
            {{ $t('CAMPAIGN.ADD.FORM.INBOX.ERROR') }}
          </span>
        </label>

        <label
          v-if="isWhatsappType"
          :class="{ error: $v.selectedStatus.$error }"
        >
          {{ $t('CAMPAIGN.ADD.FORM.STATUS.LABEL') }}
          <select v-model="selectedStatus">
            <option
              v-for="status in conversationStatuses"
              :key="status.id"
              :value="status.id"
            >
              {{ status.value.toLowerCase() }}
            </option>
          </select>
          <span v-if="$v.selectedStatus.$error" class="message">
            {{ $t('CAMPAIGN.ADD.FORM.STATUS.ERROR') }}
          </span>
        </label>

        <label
          v-if="isWhatsappType"
          :class="{ error: $v.selectedTemplate.$error }"
        >
          {{ $t('CAMPAIGN.ADD.FORM.TEMPLATE.LABEL') }}
          <select v-model="selectedTemplate" :disabled="!selectedInbox">
            <option
              v-for="(item, index) in templates"
              :key="index"
              :value="item"
            >
              {{ item.name }}
            </option>
          </select>
          <span v-if="$v.selectedTemplate.$error" class="message">
            {{ $t('CAMPAIGN.ADD.FORM.TEMPLATE.ERROR') }}
          </span>
        </label>

        <div v-if="hasAttachments" class="attachment-preview-box">
          <attachment-preview
            :attachments="attachedFiles"
            :remove-attachment="removeAttachment"
          />
        </div>

        <label
          v-else-if="
            formatTypeTemplateHeader && formatTypeTemplateHeader != 'TEXT'
          "
          :class="{ error: $v.attachedFiles.$error }"
        >
          <file-upload
            ref="images"
            name="_file"
            :accept="acceptedFormats"
            :size="acceptedSize"
            :data="{
              direct_upload_url: '/rails/active_storage/direct_uploads',
              direct_upload: true,
            }"
            @input-file="onFileUpload"
          >
            <div v-if="selectedTemplate">
              <woot-button
                class-names="button--upload"
                icon="file-upload"
                color-scheme="secondary"
                variant="smooth"
                size="small"
              >
                <span v-if="formatTypeTemplateHeader === 'IMAGE'">
                  {{ $t('WHATSAPP_TEMPLATES.PARSER.UPLOAD_IMAGE') }}
                </span>

                <span v-if="formatTypeTemplateHeader === 'DOCUMENT'">
                  {{ $t('WHATSAPP_TEMPLATES.PARSER.UPLOAD_DOCUMENT') }}
                </span>

                <span v-if="formatTypeTemplateHeader === 'VIDEO'">
                  {{ $t('WHATSAPP_TEMPLATES.PARSER.UPLOAD_VIDEO') }}
                </span>
              </woot-button>

              <small>
                Formatos permitidos: <span>{{ acceptedFormats }}</span>
              </small>
            </div>
          </file-upload>

          <span v-if="$v.attachedFiles.$error" class="message">
            Obrigatório o arquivo
          </span>
        </label>

        <label
          v-if="isOnOffType || isWhatsappType"
          class="multiselect-wrap--small"
          :class="{ error: $v.selectedAudience.$error }"
        >
          {{ $t('CAMPAIGN.ADD.FORM.AUDIENCE.LABEL') }}
          <multiselect
            v-model="selectedAudience"
            :options="audienceList"
            track-by="id"
            label="title"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :hide-selected="true"
            :placeholder="$t('CAMPAIGN.ADD.FORM.AUDIENCE.PLACEHOLDER')"
            selected-label
            :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
            :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
            @blur="$v.selectedAudience.$touch"
            @select="$v.selectedAudience.$touch"
          />
          <span v-if="$v.selectedAudience.$error" class="message">
            {{ $t('CAMPAIGN.ADD.FORM.AUDIENCE.ERROR') }}
          </span>
        </label>

        <label
          v-if="isOngoingType || isWhatsappType"
          :class="{ error: $v.selectedSender.$error }"
        >
          {{ $t('CAMPAIGN.ADD.FORM.SENT_BY.LABEL') }}
          <select
            v-model="selectedSender"
            :disabled="isWhatsappType && !selectedInbox"
          >
            <option
              v-for="sender in sendersAndBotList"
              :key="sender.name"
              :value="sender.id"
            >
              {{ sender.name }}
            </option>
          </select>
          <span v-if="$v.selectedSender.$error" class="message">
            {{ $t('CAMPAIGN.ADD.FORM.SENT_BY.ERROR') }}
          </span>
        </label>

        <label v-if="isOnOffType || isWhatsappType">
          {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
          <woot-date-time-picker
            :value="scheduledAt"
            :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
            :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
            @change="onChange"
          />
        </label>

        <woot-input
          v-if="isOngoingType"
          v-model="endPoint"
          :label="$t('CAMPAIGN.ADD.FORM.END_POINT.LABEL')"
          type="text"
          :class="{ error: $v.endPoint.$error }"
          :error="
            $v.endPoint.$error ? $t('CAMPAIGN.ADD.FORM.END_POINT.ERROR') : ''
          "
          :placeholder="$t('CAMPAIGN.ADD.FORM.END_POINT.PLACEHOLDER')"
          @blur="$v.endPoint.$touch"
        />
        <woot-input
          v-if="isOngoingType"
          v-model="timeOnPage"
          :label="$t('CAMPAIGN.ADD.FORM.TIME_ON_PAGE.LABEL')"
          type="text"
          :class="{ error: $v.timeOnPage.$error }"
          :error="
            $v.timeOnPage.$error
              ? $t('CAMPAIGN.ADD.FORM.TIME_ON_PAGE.ERROR')
              : ''
          "
          :placeholder="$t('CAMPAIGN.ADD.FORM.TIME_ON_PAGE.PLACEHOLDER')"
          @blur="$v.timeOnPage.$touch"
        />
        <label v-if="isOngoingType">
          <input
            v-model="enabled"
            type="checkbox"
            value="enabled"
            name="enabled"
          />
          {{ $t('CAMPAIGN.ADD.FORM.ENABLED') }}
        </label>
        <label v-if="isOngoingType">
          <input
            v-model="triggerOnlyDuringBusinessHours"
            type="checkbox"
            value="triggerOnlyDuringBusinessHours"
            name="triggerOnlyDuringBusinessHours"
          />
          {{ $t('CAMPAIGN.ADD.FORM.TRIGGER_ONLY_BUSINESS_HOURS') }}
        </label>
      </div>

      <div class="modal-footer">
        <woot-button :is-loading="uiFlags.isCreating">
          {{ $t('CAMPAIGN.ADD.CREATE_BUTTON_TEXT') }}
        </woot-button>
        <woot-button variant="clear" @click.prevent="onClose">
          {{ $t('CAMPAIGN.ADD.CANCEL_BUTTON_TEXT') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>

<script>
import AttachmentPreview from 'dashboard/components/widgets/AttachmentsPreview';
import FileUpload from 'vue-upload-component';

import { mapGetters } from 'vuex';
import { required, requiredIf } from 'vuelidate/lib/validators';
import alertMixin from 'shared/mixins/alertMixin';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import campaignMixin from 'shared/mixins/campaignMixin';
import templateWppMixin from 'shared/mixins/templateWppMixin';
import snoozeTimesMixin from 'dashboard/mixins/conversation/snoozeTimesMixin.js';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import { URLPattern } from 'urlpattern-polyfill';
import { CAMPAIGNS_EVENTS } from '../../../../helper/AnalyticsHelper/events';

export default {
  components: {
    AttachmentPreview,
    FileUpload,
    WootDateTimePicker,
    WootMessageEditor,
  },
  mixins: [alertMixin, campaignMixin, snoozeTimesMixin, templateWppMixin],
  data() {
    return {
      title: '',
      message: '',
      selectedSender: null,
      selectedInbox: null,
      selectedAudience: [],
      selectedTemplate: null,
      selectedStatus: 1,
      endPoint: '',
      timeOnPage: 10,
      show: true,
      enabled: true,
      triggerOnlyDuringBusinessHours: false,
      scheduledAt: null,
      senderList: [],
      templateParams: null,
    };
  },
  validations() {
    const commonValidations = {
      title: {
        required,
      },
      message: {
        required,
      },
      selectedInbox: {
        required,
      },
      attachedFiles: {
        required: requiredIf(function () {
          return (
            this.formatTypeTemplateHeader &&
            this.formatTypeTemplateHeader != 'TEXT'
          );
        }),
      },
    };
    if (this.isOngoingType) {
      return {
        ...commonValidations,
        selectedSender: {
          required,
        },
        endPoint: {
          required,
          shouldBeAValidURLPattern(value) {
            try {
              // eslint-disable-next-line
              new URLPattern(value);
              return true;
            } catch (error) {
              return false;
            }
          },
          shouldStartWithHTTP(value) {
            if (value) {
              return (
                value.startsWith('https://') || value.startsWith('http://')
              );
            }
            return false;
          },
        },
        timeOnPage: {
          required,
        },
      };
    }

    if (this.isWhatsappType) {
      commonValidations.selectedSender = { required };
      commonValidations.selectedTemplate = { required };
      commonValidations.selectedStatus = { required };
    }

    return {
      ...commonValidations,
      selectedAudience: {
        isEmpty() {
          return !!this.selectedAudience.length;
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'campaigns/getUIFlags',
      audienceList: 'labels/getLabels',
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    }),
    inboxes() {
      if (this.isOngoingType) {
        return this.$store.getters['inboxes/getWebsiteInboxes'];
      }

      if (this.isOnOffType) {
        return this.$store.getters['inboxes/getSMSInboxes'];
      }

      if (this.isWhatsappType) {
        return this.$store.getters['inboxes/getWhatsAppInboxes'];
      }
    },
    templates() {
      if (this.isWhatsappType) {
        const array = [];
        const templates = this.$store.getters['inboxes/getWhatsAppTemplates'](
          this.selectedInbox
        );

        templates.forEach(item => {
          const [header] = item.components.filter(el => el.type == 'HEADER');
          const [body] = item.components.filter(el => el.type == 'BODY');

          if (!body.text.includes('{{') && !header?.text?.includes('{{')) {
            const [exists] = array.filter(({ name }) => item.name === name);
            if (!exists) array.push(item);
          }
        });

        return array;
      }

      return [];
    },
    sendersAndBotList() {
      const sender_list = this.senderList;

      if (this.isOngoingType) {
        const bot = { id: 0, name: 'Bot' };
        return [bot, ...sender_list];
      }

      if (this.isWhatsappType) {
        return [...sender_list];
      }
    },
    formatTypeTemplateHeader() {
      if (this.selectedTemplate) {
        const [header] = this.selectedTemplate.components.filter(({ type }) => {
          return type == 'HEADER';
        });

        return header?.format;
      }
    },
    conversationStatuses() {
      return [
        {
          id: 1,
          key: 'open',
          value: this.$t('CONVERSATION.CARD_CONTEXT_MENU.OPEN'),
        },
        {
          id: 2,
          key: 'resolved',
          value: this.$t('CONVERSATION.CARD_CONTEXT_MENU.RESOLVED'),
        },
        {
          id: 3,
          key: 'pending',
          value: this.$t('CONVERSATION.CARD_CONTEXT_MENU.PENDING'),
        },
        {
          id: 4,
          key: 'snoozed',
          value: `
            ${this.$t('CONVERSATION.RESOLVE_DROPDOWN.SNOOZE.TITLE')}
            ${this.$t('CONVERSATION.RESOLVE_DROPDOWN.SNOOZE.TOMORROW')}
          `,
          snooze: this.snoozeTimes.tomorrow,
        },
        {
          id: 5,
          key: 'snoozed',
          value: `
            ${this.$t('CONVERSATION.RESOLVE_DROPDOWN.SNOOZE.TITLE')}
            ${this.$t('CONVERSATION.RESOLVE_DROPDOWN.SNOOZE.NEXT_WEEK')}
          `,
          snooze: this.snoozeTimes.nextWeek,
        },
        {
          id: 6,
          key: 'snoozed',
          value: `
            ${this.$t('CONVERSATION.RESOLVE_DROPDOWN.SNOOZE.TITLE')}
            ${this.$t('CONVERSATION.RESOLVE_DROPDOWN.SNOOZE.NEXT_REPLY')}
          `,
        },
      ];
    },
  },
  mounted() {
    this.$track(CAMPAIGNS_EVENTS.OPEN_NEW_CAMPAIGN_MODAL, {
      type: this.campaignType,
    });
  },
  methods: {
    onClose() {
      this.$emit('on-close');
    },
    onChange(value) {
      this.scheduledAt = value;
    },
    async onChangeInbox() {
      try {
        const response = await this.$store.dispatch('inboxMembers/get', {
          inboxId: this.selectedInbox,
        });
        const {
          data: { payload: inboxMembers },
        } = response;
        this.senderList = inboxMembers;
      } catch (error) {
        const errorMessage =
          error?.response?.message || this.$t('CAMPAIGN.ADD.API.ERROR_MESSAGE');
        this.showAlert(errorMessage);
      }
    },
    getCampaignDetails() {
      let campaignDetails = null;
      if (this.isOngoingType) {
        campaignDetails = {
          title: this.title,
          message: this.message,
          inbox_id: this.selectedInbox,
          sender_id: this.selectedSender || null,
          enabled: this.enabled,
          trigger_only_during_business_hours:
            // eslint-disable-next-line prettier/prettier
            this.triggerOnlyDuringBusinessHours,
          trigger_rules: {
            url: this.endPoint,
            time_on_page: this.timeOnPage,
          },
        };
      } else {
        const audience = this.selectedAudience.map(item => {
          return {
            id: item.id,
            type: 'Label',
          };
        });
        campaignDetails = {
          title: this.title,
          message: this.message,
          inbox_id: this.selectedInbox,
          scheduled_at: this.scheduledAt,
          audience,
        };

        if (this.isWhatsappType) {
          const [status] = this.conversationStatuses.filter(({ id }) => {
            return this.selectedStatus == id;
          });

          campaignDetails.sender_id = this.selectedSender;
          campaignDetails.trigger_rules = {
            status: status.key,
            template_params: this.setTemplateParams(),
          };

          if (status.snooze) {
            campaignDetails.trigger_rules.snoozed_until = status.snooze;
          }

          if (this.hasAttachments) {
            campaignDetails.file = this.attachedFiles[0].resource;
          }
        }
      }

      return campaignDetails;
    },
    async addCampaign() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      try {
        const campaignDetails = this.getCampaignDetails();
        await this.$store.dispatch('campaigns/create', campaignDetails);

        // tracking this here instead of the store to track the type of campaign
        this.$track(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
          type: this.campaignType,
        });

        this.showAlert(this.$t('CAMPAIGN.ADD.API.SUCCESS_MESSAGE'));
        this.onClose();
      } catch (error) {
        const errorMessage =
          error?.response?.message || this.$t('CAMPAIGN.ADD.API.ERROR_MESSAGE');
        this.showAlert(errorMessage);
      }
    },
    setMessage() {
      const template = this.selectedTemplate;

      const [body] = template.components.filter(({ type }) => type === 'BODY');
      const [header] = template.components.filter(
        ({ type }) => type === 'HEADER'
      );
      const [footer] = template.components.filter(
        ({ type }) => type === 'FOOTER'
      );

      let message = '';

      if (header && header.text) message = `*${header.text}* \n\n`;

      message = `${message} ${body.text}`;

      if (footer) message = `${message} \n\n ${footer.text}`;

      this.message = message;
    },
    setTemplateParams() {
      return {
        ...this.selectedTemplate,
        processed_params: { header: {}, body: {} },
      };
    },
  },
  watch: {
    selectedTemplate(new_value) {
      if (new_value) this.setMessage();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .ProseMirror-woot-style {
  height: 8rem;
}
.preview-item__wrap {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-one);
}
</style>
